import { useCallback } from 'react';
import { GiftedChat, IMessage } from 'react-native-gifted-chat';
import uuid from 'react-native-uuid';

type ExtendedMessage = IMessage & {
	conversationId?: string | null;
	to?: string | null;
	pending?: boolean;
	seen?: boolean;
};

// 1. handleMessage
const handleMessage = ({
	messages,
	conversationIdState,
	data,
	setData,
	selectedConversation,
	setMessageArray,
	socket,
}: {
	messages: ExtendedMessage[];
	conversationIdState: string;
	data: any[];
	setData: (data: any[]) => void;
	selectedConversation: {
		id: string;
		conversationId?: string;
		_id?: string;
		participantId?: string;
	};
	setMessageArray: (
		fn: (prev: ExtendedMessage[]) => ExtendedMessage[]
	) => void;
	socket: any;
}) => {
	// if (
	//   conversationIdState !== 'blank' &&
	//   data[0]?.conversationId !== conversationIdState
	// ) {
	//   const conversation = data.find(
	//     (user) => user.conversationId === conversationIdState
	//   );
	//   if (conversation) {
	//     const index = data.indexOf(conversation);
	//     const newData = [...data];
	//     newData.splice(index, 1);
	//     newData.unshift(conversation);
	//     setData(newData);
	//   }
	// }

	console.log('selected conversations', selectedConversation);

	const normalizedConversationId =
		conversationIdState ||
		selectedConversation?.conversationId ||
		selectedConversation?.id ||
		selectedConversation?._id ||
		null;

	const recipientId =
		selectedConversation?.participantId ||
		selectedConversation?.id ||
		selectedConversation?._id ||
		selectedConversation?.conversationId ||
		normalizedConversationId;

	// Generate a valid UUID v4 for the message so backend accepts it
	// Format: "ae34cdd7-9729-4e43-b0e9-ba02a004262b"
	// This prevents the backend from generating a new UUID and causing ID mismatches
	const messageId = uuid.v4() as string;

	const messageToSend: ExtendedMessage = {
		...messages[0],
		_id: messageId, // Override with valid UUID
		image: undefined,
		pending: true,
		conversationId:
			normalizedConversationId ??
			selectedConversation?.conversationId ??
			undefined,
	};

	setMessageArray((prev) => GiftedChat.append(prev, [messageToSend]));

	const payload = {
		...messageToSend,
		to: recipientId,
	};

	socket.emit('message', payload, normalizedConversationId, recipientId);
};;

// 2. clearBadge
const clearBadge = (
	user: { _id: string },
	data: { _id: string; badge: number }[],
	setData: (data: { _id: string; badge: number }[]) => void
) => {
	const newList = data.map((item) =>
		item._id === user._id ? { ...item, badge: 0 } : item
	);
	setData(newList);
};

// 3. handleClearMessages
const handleClearMessages = (
	setMessageArray: (messages: ExtendedMessage[]) => void
) => {
	setMessageArray([]);
};

// 4. Optional: messageIdCallback
const messageIdCallback = (id: string, messageArray: ExtendedMessage[]) => {
	return messageArray.find((msg) => msg._id === id);
};

// 5. Optional: getMessagesById
const getMessagesById = (
	conversationId: string,
	messageArray: ExtendedMessage[]
) => {
	return messageArray.filter((msg) => msg.conversationId === conversationId);
};

const deliveredHandler = ({
	event,
	messageArray,
	setMessageArray,
}: {
	event: any;
	messageArray: ExtendedMessage[];
	setMessageArray: (
		fn: (prev: ExtendedMessage[]) => ExtendedMessage[]
	) => void;
}) => {
	setMessageArray((prev) => {
		const messageIndex = prev.findIndex((msg) => msg._id === event?.id);
		if (messageIndex === -1) {
			// Message not found, return same array reference
			return prev;
		}

		const existingMessage = prev[messageIndex];
		// Check if update is actually needed to avoid unnecessary re-renders
		if (!existingMessage.pending && existingMessage.sent) {
			// Already in the desired state, return same array reference
			return prev;
		}

		// Create updated message
		const updatedMessage = {
			...existingMessage,
			pending: false,
			sent: true,
			received: true,
			delivered: true,
			seen: existingMessage.seen || false,
		};

		// Use GiftedChat.append pattern: remove old message and append updated one
		// This ensures Gifted Chat properly detects and renders the change immediately
		const messagesWithoutOld = prev.filter((msg) => msg._id !== event?.id);
		return GiftedChat.append(messagesWithoutOld, [
			updatedMessage,
		]) as ExtendedMessage[];
	});
};

export {
	handleMessage,
	clearBadge,
  deliveredHandler,
	handleClearMessages,
	messageIdCallback,
	getMessagesById,
};
